import React, { type ReactElement, type ReactNode } from 'react';

import { Small } from 'styled-system';

type FooterLinkProps = {
    children: ReactNode;
    link: string;
};

const FooterLink = ({ children, link }: FooterLinkProps): ReactElement => (
    <Small color="secondary" as="a" href={link} target="_blank" rel="noopener noreferrer">
        {children}
    </Small>
);

export default FooterLink;
